/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { accountSettings, card, user } from '../../api';
import { handleError } from '../../utilities/errorHandling';
import {
  MONAVATE_CARD_STATUS,
  CARD_MONAVATE_PIN_CHECK,
  USA_CARD_GET_STATUS,
  CONNECT_FINANCIAL_CARD_STATUS,
  CONNECT_FINANCIAL_CARD_ORDER_STATUS,
} from './queries';
import { USER_DETAILS_QUERY_KEY } from '../../utilities/sharedQueries';
import { cardProviders } from './constants';

const queryClient = getQuery();

export const CARD_CREATE_CRYPTODRAFT = 'card.cryptodraft.create';
export const CARD_PAY_INTEREST_PAYMENT_CRYPTODRAFT = 'card.cryptodraft.payInterestPayment';
export const CARD_CRYPTODRAFT_DEPOSIT = 'card.cryptodraft.deposit';
export const CARD_CRYPTODRAFT_PAY_SETTLEMENT = 'card.cryptodraft.payFullSettlement';
export const CARD_CRYPTODRAFT_WITHDRAWABLE = 'card.cryptodraft.getWithdrawable';
export const CARD_CRYPTODRAFT_PAY_PARTIAL = 'card.cryptodraft.payPartial';
export const CARD_CRYPTODRAFT_REQUEST_WITHDRAWAL = 'card.cryptodraft.request_withdrawal';

export const CARD_MONAVATE_ACTIVATE = 'card.monavate.activate';

export const CARD_PGW_PAYMENT_ORDER = 'card.payment.pgw_cardOrder';
export const CARD_ORDER_MONAVATE = 'card.monavate.order';
export const CARD_MONAVATE_SET_PIN = 'card.monavate.setPIN';

export const CARD_MONAVATE_TRANSACTIONS = 'card.monavate.transactions';

export const CARD_GALILEO_TRANSACTIONS = 'card.galileo.transactions';
export const CARD_GALILEO_DOWNLOAD_STATEMENT_PDF = 'card.galileo.download_statement_pdf';
export const CARD_GALILEO_DOWNLOAD_STATEMENT_PDF_NEW = 'card.galileo.download_statement_pdf_new';
export const CARD_GALILEO_SEND_STATEMENT_EMAIL = 'card.galileo.statement.sent_email';

export const CARD_UPDATE_LINKED_WALLETS = 'card.wallets.updateLinkedWallets';

export const CARD_MONAVATE_BLOCK = 'card.monavate.block';
export const CARD_MONAVATE_UNBLOCK = 'card.monavate.unblock';

export const CARD_MONAVATE_DOWNLOAD_STATEMENT_PDF = 'card.monavate.download_statement_pdf';
export const CARD_MONAVATE_DOWNLOAD_STATEMENT_CSV = 'card.monavate.download_statement_csv';

export const CARD_VISA_PIN = 'card.visa.viewPin';
export const CARD_MONAVATE_SEND_STATEMENT_EMAIL = 'card.monavate.statement.sent_email';

export const CARD_MONAVATE_REPORT_STOLEN = 'card.monavate.report.stolen';
export const CARD_MONAVATE_REPORT_LOST = 'card.monavate.report.lost';

export const CARD_GALILEO_REPORT_LOST = 'card.galileo.report.lost';
export const CARD_GALILEO_REPORT_STOLEN = 'card.galileo.report.stolen';
export const CARD_GALILEO_REPORT_DAMAGED = 'card.galileo.report.damaged';
export const CARD_ORDER_REPLACEMENT = 'card.galileo.order.replacement';
export const CARD_ENABLE = 'card.galileo.enable';
export const CARD_PIN_CHANGE_KEY = 'card.galileo.pin.change.key';

export const USA_CARD_CARD_ORDER = 'card.galileo.order';
export const USA_CARD_CARD_BLOCK = 'card.galileo.block';
export const USA_CARD_CARD_UNBLOCK = 'card.galileo.unblock';

export const CARD_CONNECT_FINANCIAL_ORDER = 'card.connectFinancial.order';
export const CARD_CONNECT_FINANCIAL_BLOCK = 'card.connectFinancial.block';
export const CARD_CONNECT_FINANCIAL_UNBLOCK = 'card.connectFinancial.unblock';
export const CARD_CONNECT_FINANCIAL_TRANSACTIONS = 'card.connectFinancial.transactions';
export const CARD_CONNECT_FINANCIAL_DOWNLOAD_STATEMENT_PDF =
  'card.connectFinancial.download_statement_pdf';

export const CARD_ORDER_PROMO = 'card.promo.order';
export const CARD_ORDER_WAITING_LIST = 'card.waitlist.order';

export const PHONE_VERIFY_SCA_OTP = 'card.sca.otp_verify';
export const PHONE_RESEND_SCA_OTP = 'card.sca.otp_resend';

export const PGW_BUY_CRYPTO = 'card.payment.buy.crypto';

export const USER_WAIT_LIST_RANK = 'user.checkWaitList';
export const CARD_CASHBACK_CURRENCY_UPDATE = 'card.cashback.currency.update';
export const CARD_SEND_CASHBACK_REWARD = 'card.send.cashback.reward';

export const CARD_UPDATE_DISPLAY_CURRENCY = 'card.updateDisplayCurrency';

queryClient.setMutationDefaults(CARD_VISA_PIN, {
  mutationFn: card.visa.viewPin,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_UPDATE_DISPLAY_CURRENCY, {
  mutationFn: card.updateDisplayCurrency,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PGW_BUY_CRYPTO, {
  mutationFn: card.payment.buyCrypto,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_VERIFY_SCA_OTP, {
  mutationFn: card.sca.verifyOtp,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_RESEND_SCA_OTP, {
  mutationFn: card.sca.resendOtp,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CREATE_CRYPTODRAFT, {
  mutationFn: card.cryptodraft.create,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_PAY_INTEREST_PAYMENT_CRYPTODRAFT, {
  mutationFn: card.cryptodraft.payInterestPayment,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CRYPTODRAFT_DEPOSIT, {
  mutationFn: card.cryptodraft.deposit,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_PGW_PAYMENT_ORDER, {
  mutationFn: card.payment.orderCard,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_ACTIVATE, {
  mutationFn: card.monavate.activate,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_ORDER_MONAVATE, {
  mutationFn: card.monavate.order,
  onSuccess: async () => {
    await queryClient.invalidateQueries(MONAVATE_CARD_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_SET_PIN, {
  mutationFn: card.monavate.setPIN,
  onSuccess: async () => {
    await queryClient.invalidateQueries(CARD_MONAVATE_PIN_CHECK);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USA_CARD_CARD_ORDER, {
  mutationFn: card.galileo.order,
  onError: (error) => {
    handleError(error);
  },
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
});

queryClient.setMutationDefaults(CARD_ORDER_PROMO, {
  mutationFn: card.promo.order,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_ORDER_WAITING_LIST, {
  mutationFn: card.waiting.order,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CRYPTODRAFT_PAY_SETTLEMENT, {
  mutationFn: card.cryptodraft.payFullSettlement,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_UPDATE_LINKED_WALLETS, {
  mutationFn: card.wallets.updateLinkedWallets,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CRYPTODRAFT_WITHDRAWABLE, {
  mutationFn: card.cryptodraft.getWithdrawableAmount,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CRYPTODRAFT_PAY_PARTIAL, {
  mutationFn: card.cryptodraft.payPartial,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CRYPTODRAFT_REQUEST_WITHDRAWAL, {
  mutationFn: card.cryptodraft.requestCollateralWithdrawal,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_TRANSACTIONS, {
  mutationFn: card.monavate.transactions,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_GALILEO_TRANSACTIONS, {
  mutationFn: card.galileo.transactions,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_BLOCK, {
  mutationFn: card.monavate.block,
  onSuccess: async () => {
    await queryClient.invalidateQueries(MONAVATE_CARD_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_UNBLOCK, {
  mutationFn: card.monavate.unblock,
  onSuccess: async () => {
    await queryClient.invalidateQueries(MONAVATE_CARD_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_DOWNLOAD_STATEMENT_PDF, {
  mutationFn: card.monavate.statement,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_DOWNLOAD_STATEMENT_CSV, {
  mutationFn: card.monavate.statementCSV,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_SEND_STATEMENT_EMAIL, {
  mutationFn: card.monavate.sendStatementEmail,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_REPORT_STOLEN, {
  mutationFn: card.monavate.cardReportStolen,
  onSuccess: async () => {
    await queryClient.invalidateQueries(MONAVATE_CARD_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_MONAVATE_REPORT_LOST, {
  mutationFn: card.monavate.cardReportLost,
  onSuccess: async () => {
    await queryClient.invalidateQueries(MONAVATE_CARD_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_GALILEO_REPORT_LOST, {
  mutationFn: card.galileo.cardReportLost,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_GALILEO_REPORT_STOLEN, {
  mutationFn: card.galileo.cardReportStolen,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_GALILEO_REPORT_DAMAGED, {
  mutationFn: card.galileo.cardReportDamaged,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});
queryClient.setMutationDefaults(CARD_ORDER_REPLACEMENT, {
  mutationFn: card.galileo.cardOrderReplacement,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_PIN_CHANGE_KEY, {
  mutationFn: card.galileo.cardPinChangeKey,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_ENABLE, {
  mutationFn: card.galileo.cardEnable,
  onError: (error) => {
    handleError(error);
  },
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
  },
});

queryClient.setMutationDefaults(USER_WAIT_LIST_RANK, {
  mutationFn: user.checkWaitList,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CASHBACK_CURRENCY_UPDATE, {
  mutationFn: accountSettings.updateRewardCashbackCurrency,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_SEND_CASHBACK_REWARD, {
  mutationFn: accountSettings.sendCashbackRewardToUser,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USA_CARD_CARD_BLOCK, {
  mutationFn: card.galileo.block,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USA_CARD_CARD_UNBLOCK, {
  mutationFn: card.galileo.unblock,
  onSuccess: async () => {
    await queryClient.invalidateQueries(USA_CARD_GET_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_GALILEO_DOWNLOAD_STATEMENT_PDF, {
  mutationFn: card.galileo.statement,
  onError: (error) => handleError(error),
});

queryClient.setMutationDefaults(CARD_CONNECT_FINANCIAL_ORDER, {
  mutationFn: card.connectFinancial.order,
  onError: (error) => {
    handleError(error);
  },
  onSuccess: async () => {
    await queryClient.invalidateQueries(CONNECT_FINANCIAL_CARD_STATUS);
    await queryClient.invalidateQueries(CONNECT_FINANCIAL_CARD_ORDER_STATUS);
    await queryClient.invalidateQueries(USER_DETAILS_QUERY_KEY);
  },
});

queryClient.setMutationDefaults(CARD_CONNECT_FINANCIAL_BLOCK, {
  mutationFn: card.connectFinancial.block,
  onSuccess: async () => {
    await queryClient.invalidateQueries(CONNECT_FINANCIAL_CARD_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CONNECT_FINANCIAL_UNBLOCK, {
  mutationFn: card.connectFinancial.unblock,
  onSuccess: async () => {
    await queryClient.invalidateQueries(CONNECT_FINANCIAL_CARD_STATUS);
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CONNECT_FINANCIAL_TRANSACTIONS, {
  mutationFn: card.connectFinancial.transactions,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(CARD_CONNECT_FINANCIAL_DOWNLOAD_STATEMENT_PDF, {
  mutationFn: card.connectFinancial.statement,
  onError: (error) => handleError(error),
});

queryClient.setMutationDefaults(CARD_GALILEO_DOWNLOAD_STATEMENT_PDF_NEW, {
  mutationFn: card.galileo.statementNew,
  onError: (error) => handleError(error),
});

queryClient.setMutationDefaults(CARD_GALILEO_SEND_STATEMENT_EMAIL, {
  mutationFn: card.galileo.sendStatementEmail,
  onError: (error) => handleError(error),
});

export const resolveStatementDownloadMutationKey = (cardProvider, newPdfEndpointEnabled) => {
  if (cardProvider === cardProviders.CONNECT_FINANCIAL) {
    return CARD_CONNECT_FINANCIAL_DOWNLOAD_STATEMENT_PDF;
  }
  if (cardProvider === cardProviders.MONAVATE) {
    return CARD_MONAVATE_DOWNLOAD_STATEMENT_CSV;
  }
  return newPdfEndpointEnabled
    ? CARD_GALILEO_DOWNLOAD_STATEMENT_PDF_NEW
    : CARD_GALILEO_DOWNLOAD_STATEMENT_PDF;
};
